import(/* webpackMode: "eager" */ "/app/src/app/tools/data-sorter/page.tsx");
